// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__Q7FW7","button":"Carousel_button__2EZaW","carousel":"Carousel_carousel__HUuPG"};